export default {
  unsubscribeLink: 'Me désinscrire',
  detailsLink: ' Détails du concours',
  unsubscribeConfirmationTitle: 'Désirez-vous vraiment vous désinscrire ?',
  detailsModalTitle: 'Détails du concours',
  detailsModalClose: 'Fermer',
  contestRulesUriLabel: 'Consulter le règlement du concours.',
};
